import Layout from '@/components/feature/Layout';
import useSEO from '@/hooks/useSEO';
import SEOJsonLd from '@/components/base/SEOJsonLd';
import ExperienceContent from './components/ExperienceContent';

export default function ExperiencePage() {
  const siteUrl = (window as any).__VITE_SITE_URL__ || 'https://kangyong.com';
  useSEO({
    title: '服務經驗｜250+ 品牌信賴的保健食品代工夥伴｜康永生技',
    description: '康永生技深耕保健食品代工超過20年，累積 250+ 品牌合作經驗、1600+ 配方數據庫，70% 回單生產率見證客戶信賴。',
    keywords: '康永服務經驗,保健食品代工經驗,品牌合作,配方數據庫,代工實績',
    lang: 'zh-TW',
    canonicalPath: '/home/experience',
  });

  return (
    <Layout>
      <SEOJsonLd type="WebPage" pageTitle="服務經驗｜250+ 品牌信賴的保健食品代工夥伴｜康永生技" pageDescription="康永生技深耕保健食品代工超過20年，累積 250+ 品牌合作經驗、1600+ 配方數據庫，70% 回單生產率見證客戶信賴。" pageUrl={`${siteUrl}/home/experience`} />
      <ExperienceContent />
    </Layout>
  );
}